export default "__VITE_ASSET__DNogwBVb__"